import api from "../api/base-api"

const campaignApi = api.injectEndpoints({
        endpoints: (build) => ({

            getTransferStatus: build.query({
                query: (data) => {
                    return {
                        'url': '/admin/transfer/get',
                        env:data.env
                    }
                },
            }),
            getAllParams: build.query({
                query: () => '/admin/parameter/getAll',
            }),

            getAllBundles: build.query({
                query: (ev) => `/admin/bundle/getAll?environment=${ev}`,
                keepUnusedDataFor: 0
            }),
            getBundleHistory: build.query({
                query: (data) => {
                    return {
                        'url': `/admin/bundle/history?environment=${data.env}&bundle=${data.bundle}`,
                        env:data.env
                    }
                },
                keepUnusedDataFor: 0
            }),
            getCampaigns: build.query({
                query: (data) => {
                    return {
                        url: `/admin/campaign/search?environment=${data.env}&id=${data.id}`,
                        env: data.env
                    }
                },
            }),
            findCampaignById: build.query({
                query: (data) => `/admin/campaign/select?environment=${data.ev}&id=${data.id}`,
                providesTags: (result, error, arg) => {
                    return result
                        ? [{type: 'Campaign', id:result.id}, 'Campaign']
                        : ['Campaign']
                }
            }),
            getAllCampaigns: build.query({
                query: (data) => {
                    let query = '';
                    if(data.hasOwnProperty('from')) {
                        query = `&from=${data.from}&till=${data.till}`
                    }
                    return {
                        url: `/admin/publisher/context?environment=${data.env}`+query,
                        env: data.env
                    }
                },
                keepUnusedDataFor: 0,
                providesTags: ['campaignsList'],

            }),
            getConfigCheck: build.query({
                query: (data) => {
                    let query = '';
                    if(data.hasOwnProperty('from')) {
                        query = `&from=${data.from}&till=${data.till}`
                    }
                    return {
                        url: `/admin/publisher/context/verify?environment=${data.env}`+query,
                        env: data.env
                    }
                },
                keepUnusedDataFor: 0,
            }),
            saveCampaign: build.mutation({
                query: (data) => {
                    const {ev, original, ...body} = data
                    let url = `/admin/campaign/save?environment=${ev}`;
                    // Если параметр original существует, добавляем его в URL
                    if (original) {
                        url += `&original=${original}`;
                    }
                    return {
                        url: url,
                        method: "POST",
                        body: body.body,
                        env: body.env
                    }
                },
                invalidatesTags: ['campaignsList','Campaign']

            }),
            transfer: build.mutation({
                query: (data) => {
                    const {environment, source, campaign, env} = data

                    let params = `environment=${environment}&source=${source}&campaign=${campaign}`
                    if(data.hasOwnProperty('skipBundleUpdate') && data?.skipBundleUpdate == true) {
                        params += `&skipBundleUpdate=true`
                    }

                    return {
                        url: `/admin/transfer/transfer?${params}`,
                        method: "POST",
                        body: data,
                        env: env
                    }
                },
                invalidatesTags: ['campaignsList']

            }),
            getDiff: build.query({
                query: (data) => {
                    const {environment, source, campaign, env} = data
                    return {
                        url: `/admin/transfer/bundle/diff?environment=${environment}&source=${source}&campaign=${campaign}`,
                        env: env
                    }
                },
                keepUnusedDataFor: 0
            }),
            getHistory: build.query({
                query: (data) => {
                    const {environment, event_id} = data
                    let url = `/admin/log/select?environment=${environment}`
                    if(event_id!=undefined) {
                        url += `&campaign=${event_id}`
                    }
                    return {
                        url: url,
                        env: environment
                    }
                },
                keepUnusedDataFor: 0
            }),
            getPreHistory: build.query({
                query: (data) => {
                    const {environment,source,event_id} = data
                    let url = `/admin/transfer/difference?source=${source}&environment=${environment}`
                    if(event_id!=undefined) {
                        url += `&campaign=${event_id}`
                    }
                    return {
                        url: url,
                        env: environment
                    }
                },
                keepUnusedDataFor: 0
            }),
            getHistoryAll: build.query({
                query: (data) => {
                    const {environment, event_id} = data
                    let url = `/admin/log/search?environment=${environment}`
                    if(event_id!=undefined) {
                        url += `&campaign=${event_id}`
                    }
                    return {
                        url: url,
                        env: environment
                    }
                },
                keepUnusedDataFor: 0
            }),
            getPlatformsInfo: build.query({
                query: (data) => {
                    const {env, campaign} = data;
                    return {
                        url: `/admin/bundle/check?environment=${env}&campaign=${campaign}`,
                        env: env,
                        method: "GET"
                    }
                },
                keepUnusedDataFor: 0,
                providesTags: ['platfromsInfo']

            }),
            setStatus: build.mutation({
                query: (data) => {
                    const {environment, status, id} = data

                    return {
                        url: `/admin/campaign/status?environment=${environment}&id=${id}&status=${status}`,
                        method: "POST",
                        body: data,
                        env: data.environment
                    }
                }
            }),
            activate: build.mutation({
                query: (data) => {
                    const {environment, id} = data

                    return {
                        url: `/admin/campaign/activate?environment=${environment}&id=${id}`,
                        method: "POST",
                        body: data,
                        env: data.environment
                    }
                },
                invalidatesTags: ['campaignsList']
            }),
            // current balance sheet hash, the sheet is read by stage for any environment
            getBalanceHash: build.query({
                query: ({link}) => `/admin/bundle/balance/hash?link=${encodeURIComponent(link)}`,
                keepUnusedDataFor: 0
            }),
            // "its ok": saves the current hashes into fixed bundles of all campaigns with this bundle
            acceptBalance: build.mutation({
                query: ({env, campaign}) => ({
                    url: `/admin/publisher/balance/accept?environment=${env}&campaign=${campaign}`,
                    method: "POST",
                    env: env
                }),
                invalidatesTags: ['platfromsInfo']
            }),
            upgrade: build.mutation({
                query: (data) => {
                    const {environment, id} = data

                    return {
                        url: `/admin/bundle/upgrade?environment=${environment}&bundleId=${id}`,
                        method: "POST",
                        body: data,
                        env: data.environment
                    }
                },
                invalidatesTags: ['campaignsList']
            }),
            checkCampaignTransferStatus: build.query({
                query: (data) => {

                    return {
                        url: `/admin/transfer/check?transfer_id=${data.transferId}`,
                        method: "GET",
                        env:data.env
                    }
                }
            }),
            getTags: build.query({
                query: (env) => {

                    return {
                        url: `/admin/campaign/tags?environment=${env}`,
                        method: "GET",
                        env:env
                    }
                }
            }),

            rollbackBundle: build.mutation({
                query: (data) => {
                    const {environment, bundle, generation, version} = data

                    return {
                        url: `/admin/bundle/rollback?environment=${environment}&bundle=${bundle}&generation=${generation}&version=${version}`,
                        method: "POST",
                        body: data,
                        env: environment
                    }
                }
            }),
            rollbackAllBundle: build.mutation({
                query: (data) => {
                    const {bundle, generation, version} = data

                    return {
                        url: `/admin/bundle/rollback/all?bundle=${bundle}&generation=${generation}&version=${version}`,
                        method: "POST",
                        body: data,
                    }
                }
            }),
            deleteBundle: build.mutation({
                query: (data) => {
                    const {bundle, generation, environment} = data

                    return {
                        url: `/admin/bundle/delete?bundle=${bundle}&generation=${generation}&environment=${environment}&force=true`,
                        method: "POST",
                        body: data,
                    }
                },
                invalidatesTags: ['platfromsInfo']
            }),
            deleteAllBundle: build.mutation({
                query: (data) => {
                    const {bundle, generation, version} = data

                    return {
                        url: `/admin/bundle/delete/all?bundle=${bundle}&generation=${generation}&force=true`,
                        method: "POST",
                        body: data,
                    }
                },
                invalidatesTags: ['platfromsInfo']
            }),
        }),
    }
)

export const {

    useGetDiffQuery,
    useGetHistoryQuery,
    useGetPreHistoryQuery,
    useGetHistoryAllQuery,
    useGetTransferStatusQuery,
    useGetAllParamsQuery,
    useGetAllBundlesQuery,
    useGetTagsQuery,
    useGetBundleHistoryQuery,
    useGetCampaignsQuery,
    useGetAllCampaignsQuery,
    useGetConfigCheckQuery,
    useFindCampaignByIdQuery,
    useRollbackBundleMutation,
    useRollbackAllBundleMutation,
    useDeleteBundleMutation,
    useDeleteAllBundleMutation,
    useSaveCampaignMutation,
    useTransferMutation,
    useSetStatusMutation,
    useActivateMutation,
    useLazyGetBalanceHashQuery,
    useAcceptBalanceMutation,
    useUpgradeMutation,
    useGetPlatformsInfoQuery,
    useCheckCampaignTransferStatusQuery
} = campaignApi;